import api from './client';

// ModernWash V1 is deliberately exposed through the backend adapter only.
// The browser never receives its service credentials or talks to V1 directly.
const LEGACY_BASE = '/owner-console/modernwash';

export const getModernwashLegacyMemberDetail = (memberId) =>
  api.get(`${LEGACY_BASE}/members/${encodeURIComponent(memberId)}`)
    .then((response) => response.data);

export const getModernwashLegacyMembers = (params) =>
  api.get(`${LEGACY_BASE}/members`, { params })
    .then((response) => response.data);

export const getModernwashLegacySubscriptions = () =>
  api.get(`${LEGACY_BASE}/subscriptions`).then((response) => response.data);

export const getModernwashLegacySales = (params) =>
  api.get(`${LEGACY_BASE}/sales`, { params }).then((response) => response.data);
